import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'
import Elevation from '@segment/matcha/components/Elevation'

import SubjectRightsManagementPng2x from './assets/SubjectRightsManagement@2x.png'
import SubjectRightsManagementWebp from './assets/SubjectRightsManagement.webp'
import SubjectRightsManagementWebp2x from './assets/SubjectRightsManagement@2x.webp'
import SubjectRightsManagementWebp3x from './assets/SubjectRightsManagement@3x.webp'

const SubjectRightsManagementImage = () => {
  return (
    <ElevationComponent elevation={6}>
      <Picture>
        <source
          type="image/webp"
          srcSet={`${SubjectRightsManagementWebp}, ${SubjectRightsManagementWebp2x} 2x, ${SubjectRightsManagementWebp3x} 3x`}
        />
        <StyledImage
          width="640"
          height="721"
          src={SubjectRightsManagementPng2x}
          alt="Illustration: Streamline your regulatory compliance"
          loading="lazy"
        />
      </Picture>
    </ElevationComponent>
  )
}

const Picture = styled.picture`
  max-width: 640px;
`

const StyledImage = styled(Image)`
  object-fit: contain;
`

const ElevationComponent = styled(Elevation)`
  border-radius: 8px;
`

export default SubjectRightsManagementImage
